var map = {
	"./archive.svg": 899,
	"./arrow-bottom-mobile.svg": 900,
	"./arrow-bottom.svg": 901,
	"./arrow-extreme.svg": 902,
	"./arrow-left-mobile.svg": 903,
	"./arrow-left.svg": 904,
	"./arrow-login.svg": 905,
	"./arrow-right.svg": 906,
	"./arrow-solid-bottom.svg": 907,
	"./arrow.svg": 908,
	"./arrow_table.svg": 909,
	"./attention.svg": 910,
	"./b.svg": 911,
	"./back.svg": 912,
	"./beef.svg": 913,
	"./bill.svg": 914,
	"./biochemical.svg": 915,
	"./blank.svg": 916,
	"./calendar.svg": 917,
	"./carrot.svg": 918,
	"./check.svg": 919,
	"./circle.svg": 920,
	"./clock.svg": 921,
	"./cloud.svg": 922,
	"./copy-down.svg": 923,
	"./copy-up.svg": 924,
	"./copy.svg": 925,
	"./cross.svg": 926,
	"./dd_logo-short.svg": 927,
	"./dd_logo.svg": 928,
	"./dd_logo_small.svg": 929,
	"./dd_logo_white.svg": 930,
	"./del.svg": 931,
	"./double-arrow-down.svg": 932,
	"./edit.svg": 933,
	"./error.svg": 934,
	"./eye-crossed.svg": 935,
	"./eye.svg": 936,
	"./fish.svg": 937,
	"./fruit.svg": 938,
	"./genetic.svg": 939,
	"./graph.svg": 940,
	"./i.svg": 941,
	"./icon_arrow_small_l.svg": 942,
	"./icon_info.svg": 943,
	"./infinity.svg": 944,
	"./info.svg": 945,
	"./lens.svg": 946,
	"./list.svg": 947,
	"./list_o.svg": 948,
	"./list_u.svg": 949,
	"./logo-login-mobile.svg": 950,
	"./logo-short.svg": 951,
	"./logo.svg": 952,
	"./logo_small.svg": 953,
	"./logo_white.svg": 954,
	"./logout.svg": 955,
	"./microelements.svg": 956,
	"./minus.svg": 957,
	"./moon.svg": 958,
	"./normweight.svg": 959,
	"./patient-card.svg": 960,
	"./payment_maestro.svg": 961,
	"./payment_mastercard.svg": 962,
	"./payment_mir.svg": 963,
	"./payment_visa.svg": 964,
	"./pdf.svg": 965,
	"./person.svg": 966,
	"./photo.svg": 967,
	"./plus.svg": 968,
	"./printer.svg": 969,
	"./qa.svg": 970,
	"./question.svg": 971,
	"./recovery.svg": 972,
	"./refresh.svg": 973,
	"./restore.svg": 974,
	"./revert.svg": 975,
	"./right_arrow.svg": 976,
	"./rouble.svg": 977,
	"./save.svg": 978,
	"./search.svg": 979,
	"./signup.svg": 980,
	"./soup.svg": 981,
	"./sun.svg": 982,
	"./sun_full.svg": 983,
	"./sun_rising.svg": 984,
	"./supplement.svg": 985,
	"./telegram.svg": 986,
	"./thinCross.svg": 987,
	"./thinTick.svg": 988,
	"./tick.svg": 989,
	"./time.svg": 990,
	"./trueArrow.svg": 991,
	"./universal.svg": 992,
	"./urine.svg": 993,
	"./v.svg": 994,
	"./vitamins.svg": 995,
	"./welcome_abort.svg": 996,
	"./welcome_ration.svg": 997,
	"./welcome_schedule.svg": 998,
	"./welcome_time.svg": 999,
	"./welcome_trust.svg": 1000
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 898;